import { GET_HOME_INFO } from '../../constants';

/**
 * Busca o payload agregado da capa (endpoint @home-info): banner, highlights,
 * blocos da home e destaques — no padrão da extranet do TSE.
 */
export function getHomeInfo() {
  return {
    type: GET_HOME_INFO,
    request: {
      op: 'get',
      path: `/@home-info`,
    },
  };
}
